import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-query",
  "use": "icon-query-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-query\"><defs><style type=\"text/css\"></style></defs><path d=\"M768 32a160 160 0 0 1 159.68 149.504L928 192v384h-64V192a96 96 0 0 0-86.784-95.552L768 96H256a96 96 0 0 0-95.552 86.784L160 192v640a96 96 0 0 0 86.784 95.552L256 928h320v64H256a160 160 0 0 1-159.68-149.504L96 832V192A160 160 0 0 1 245.504 32.32L256 32h512zM640 512a192 192 0 0 1 156.48 303.232l71.424 71.424a32 32 0 0 1-45.248 45.248l-71.424-71.424A192 192 0 1 1 640 512z m0 64a128 128 0 1 0 0 256 128 128 0 0 0 0-256zM448 512v64H256V512h192z m320-128v64H256V384h512z m0-128v64H256V256h512z\" p-id=\"1181\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/query.svg
// module id = jEPy
// module chunks = 34